export default __webpack_public_path__ + "static/media/default-image.5e29f2bf.jpg";